const Styles = {
  Color: {
    PrimaryGray1: '#FCFDFF',
    PrimaryGray2: '#ECF2F5',
    SecondaryGray1: '#F6F9FB',
    SecondaryGray2: '#E0E2E7',
    SecondaryGray4: '#868890',
    PrimaryDarkBlue: '#233A4F',
    PrimaryBlack: '#232325',
    PrimaryBlue: '#4872DE',
    SecondaryRed: '#F32D2D',
  },
}

export default Styles
